/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import { AnyAction } from 'redux';
import { AUTH_LOGIN, AUTH_LOGOUT, LOGIN_ERROR, SEEN_HCP, SEEN_ISI } from '../../../constants/auth.constants';
import AuthState from '../../../models/redux/state/auth.state';

const initialState: AuthState = {
  user: undefined,
  hasSeenHCP: false,
  hasSeenISI: false,
  errorMessage: null,
};

const authReducer = produce((draft: AuthState, action: AnyAction) => {
  switch (action.type) {
    case AUTH_LOGIN:
      draft.user = action.user;
      break;
    case AUTH_LOGOUT:
      draft.user = initialState.user;
      break;
    case SEEN_HCP:
      draft.hasSeenHCP = action.hasSeen;
      break;
    case SEEN_ISI:
      draft.hasSeenISI = action.hasSeen;
      break;
    case LOGIN_ERROR:
      draft.errorMessage = action.errorMessage;
      break;
    default:
  }
}, initialState);

export default authReducer;
